export const MESSAGE_UNAUTHORIZED = 'You cannot perform this action'
export const MESSAGE_USER_EDIT_UNAUTHORIZED = 'You are not authorized to modify users'
export const MESSAGE_AUDITS_UNAUTHORIZED = 'You are not authorized to audit observations'
